import type { ResponsiveImage } from '../../../amplienceTypes/schemas/exported/section-image-text-schema';
import type { IAmplienceResponsiveImageParams } from '../utils/createImageUrlFromLinkImage';

import createImageUrlFromLinkImage from '../utils/createImageUrlFromLinkImage';

type ImagesType = ResponsiveImage | undefined;

interface IImageMetaData {
  metadata?: {
    width: number;
    height: number;
    pointOfInterest?: {
      x: number;
      y: number;
      w: number;
      h: number;
      [key: string]: unknown;
    };
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

// TODO: check if metadata can be typed better
export interface IResponsiveImage {
  src: string;
  media?: string;
  metadata?: IImageMetaData;
  params?: string | null;
}

export interface IParsedResponsiveImages {
  alt?: string;
  mobile?: IResponsiveImage;
  mobileParams?: string;
  tablet?: IResponsiveImage;
  tabletParams?: string;
  desktop?: IResponsiveImage;
  desktopParams?: string;
}

export const createResponsiveImageObject = (
  responsiveImage?: ImagesType,
  params?: IAmplienceResponsiveImageParams
): IParsedResponsiveImages => {
  const imageObjects: IParsedResponsiveImages = {
    alt: responsiveImage?.alt || '',
  };

  if (responsiveImage?.images?.desktop) {
    imageObjects.desktop = {
      src: createImageUrlFromLinkImage(
        responsiveImage.images.desktop,
        responsiveImage.images?.desktopParams || params?.desktop
      ),
      media: '(min-width: 1024px)',
      metadata: (responsiveImage?.images?.desktop?.metadata || null) as IImageMetaData,
    };
  }

  // if (responsiveImage?.images?.desktopParams) {
  //   imageObjects.desktopParams = responsiveImage.images.desktopParams;
  // }

  if (responsiveImage?.images?.tablet) {
    imageObjects.tablet = {
      src: createImageUrlFromLinkImage(
        responsiveImage.images.tablet,
        responsiveImage.images?.tabletParams || params?.tablet
      ),
      media: '(min-width: 768px)',
      metadata: (responsiveImage?.images?.tablet?.metadata || null) as IImageMetaData,
    };
  }

  // if (responsiveImage?.images?.tabletParams) {
  //   imageObjects.tabletParams = responsiveImage.images.tabletParams;
  // }

  if (responsiveImage?.images?.mobile) {
    imageObjects.mobile = {
      src: createImageUrlFromLinkImage(
        responsiveImage.images.mobile,
        responsiveImage.images?.mobileParams || params?.mobile
      ),
      media: '(min-width: 0px)',
      metadata: (responsiveImage?.images?.mobile?.metadata || null) as IImageMetaData,
    };
  }

  // if (responsiveImage?.images?.mobileParams) {
  //   imageObjects.mobileParams = responsiveImage.images.mobileParams;
  // }

  return imageObjects;
};

const useResponsiveImage = (
  responsiveImage?: ResponsiveImage,
  params?: IAmplienceResponsiveImageParams
): IParsedResponsiveImages => createResponsiveImageObject(responsiveImage, params);

export default useResponsiveImage;
